import { createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { SalesService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useResErrors } from '../../../hooks'
import { parseJson } from '../../../lib/utils'
import { useSnackbar } from 'notistack'
import CsContractsService from 'lib/api/services/csContracts.service'

export const WorkListViewSppStoreContext = createContext({
  store: {},
  actions: {}
})

export const WorkListViewStoreProviderSpp = props => {
  const { id } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { standardCheck, silentCheck } = useResErrors()

  const [wlData, setWlData] = useState(null)
  const [contractData, setContractData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getSale()
  }, [id])

  useEffect(() => {
    getContract()
  }, [wlData?.globalId])

  const getSale = async () => {
    if (id) {
      setLoading(true)
      await SalesService.getSaleByIdForView(id).then(response =>
        standardCheck(response, ({ data }) => {
          setWlData({ ...data, commentsRSE: parseJson(data?.commentsRSE, {}) })
        })
      )
      setLoading(false)
    }
  }

  const getContract = async () => {
    if (wlData?.globalId) {
      setLoading(true)
      await CsContractsService.getContract(wlData?.globalId).then(response =>
        silentCheck(response, ({ data }) => {
          if (data) {
            setContractData(data)
          }
        })
      )
      setLoading(false)
    }
  }

  const handleApproveSpp = async isApproved => {
    setLoading(true)
    await SalesService.updateSale({
      id: wlData?.id,
      globalId: wlData?.globalId,
      sppApprove: isApproved
    }).then(res =>
      standardCheck(res, ({ data }) => {
        if (data) {
          enqueueSnackbar(
            isApproved ? 'Успешно согласован!' : 'Запрос отказан',
            { variant: 'success' }
          )
          getSale()
        }
      })
    )

    await SalesService.updateStatusTrack(wlData?.id, 60).then(res =>
      standardCheck(res, ({ data }) => {})
    )
    setLoading(false)
  }

  const store = {
    wlData,
    loading,
    contractData
  }

  const actions = {
    setLoading,
    getSale,
    handleApproveSpp
  }

  return (
    <WorkListViewSppStoreContext.Provider value={{ store, actions }}>
      {props.children}
      <LoaderBackdrop loading={loading} />
    </WorkListViewSppStoreContext.Provider>
  )
}

export default WorkListViewStoreProviderSpp

export const useWorkListViewSppStore = () =>
  useContext(WorkListViewSppStoreContext)

export const withWorkListViewStore = Component => props =>
  (
    <WorkListViewSppStoreContext.Consumer>
      {state => <Component {...props} {...state} />}
    </WorkListViewSppStoreContext.Consumer>
  )
